/* eslint-disable prettier/prettier */
import React from 'react';
import { db, firebase, sendEmail } from "firebase/fbConfig.js";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import moment from 'moment';

import ReactTable from 'react-table';
import DateTimePicker from 'react-datetime-picker'

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Switch from "@material-ui/core/Switch";
import Checkbox from '@material-ui/core/Checkbox';
import green from '@material-ui/core/colors/green';

import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

const GreenCheckbox = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


class TaskViewer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allTaskData: [],
            uncompletedTaskData: [],
            viewCompleted: false
        };

        this.dashColumns = [
            {
                Header: "Order ID",
                accessor: 'freightBillNumber',
                sortable: false,
                filterable: false
            },
            {
                Header: "Entity",
                accessor: 'name',
                sortable: false,
                filterable: false
            },

        ];

        this.orderColumns = [
            {
                Header: "Assigned To",
                accessor: "taskAssignee",
            },
        ]

        this.taskColumns = [
            ...(this.props.onOrderPage ? this.orderColumns : this.dashColumns),
            {
                Header: "Assigned At",
                accessor: 'taskAssignedAt',
                sortable: false,
                filterable: false
            },
            {
                Header: "Due Date",
                accessor: "taskDueDate",
                sortable: false,
                filterable: false
            },
            {
                Header: "Assigned By",
                accessor: "taskAssigner",
            },
            {
                Header: "Description",
                accessor: "taskDescription",
                sortable: false,
                filterable: false
            },
            {
                Header: "Completed?",
                accessor: "completed"
            },
            {
                Header: "Go To Record",
                accessor: "goToOrder",
            },

        ];
    }

    componentDidMount() {
        this.getTaskRows();
    }

    handleChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    }

    handleSelectChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleDateTimeChange = (date) => {
        this.setState({
            taskDueDate: date
        })
    }

    handleToggleChange = (e) => {
        const { name } = e.target;
        this.setState(prevState => prevState[name] = !prevState[name]);
    }

    handleToggleCompletedChange = (e, i) => {
        const { name } = e.target;
        const { allTaskData, uncompletedTaskData, viewCompleted } = this.state;
        let index;

        if (!viewCompleted) {
            index = allTaskData.findIndex(task => task.id === uncompletedTaskData[i].id);
        } else {
            index = i;
        }

        allTaskData[index][name] = !Boolean(allTaskData[index][name])

        db.collection('tasks').doc(allTaskData[index].id).set({
            completed: allTaskData[index][name]
        }, { merge: true })
        this.setTaskState(allTaskData);
    }

    getTaskRows = () => {
        const query = this.props.onOrderPage ? 
            db.collection('tasks').where('orderID', '==', this.props.orderID ? this.props.orderID : "").where('instanceOwner', '==', 'Haney Freightways') 
            : (this.props.onProfilePage ? db.collection('tasks').where('entityID', '==', this.props.entityID ? this.props.entityID : "") 
            : db.collection('tasks').where('assignedTo', '==', this.props.user.uid ? this.props.user.uid : "").where('instanceOwner', '==', 'Haney Freightways'))

        query.get()
            .then(snapshot => {
                const allTaskData = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data()
                })).sort((a, b) => {
                    const aDate = a.taskDueDate.toDate();
                    const bDate = b.taskDueDate.toDate();

                    if (aDate < bDate) return -1;
                    if (aDate > bDate) return 1;
                    return 0;
                });

                this.setTaskState(allTaskData);
            })
    }

    setTaskState = (allTaskData) => {
        const uncompletedTaskData = allTaskData.filter(task => !task.completed);
        this.setState({
            allTaskData,
            uncompletedTaskData
        });
    }

    render() {
        const { classes } = this.props;

        // console.log(this.state);
        // console.log(this.props);

        const taskData = this.state.viewCompleted ? this.state.allTaskData : this.state.uncompletedTaskData;

        return this.state.allTaskData.length ? (
            <GridContainer justify='center'>
                <GridItem xs={12} style={{ textAlign: "center" }}>
                    <h3><b>ASSIGNED TASKS</b></h3>
                </GridItem>
                <GridItem xs={12} >
                    <GridContainer justify='center'>
                        <GridItem>
                            View Completed?
                            <Switch
                                checked={this.state.viewCompleted}
                                onChange={this.handleToggleChange}
                                name="viewCompleted"
                                classes={{
                                    switchBase: classes.switchBase,
                                    checked: classes.switchChecked,
                                    icon: classes.switchIcon,
                                    iconChecked: classes.switchIconChecked,
                                    bar: classes.switchBar,
                                }}
                            />
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem xs={12} sm={9}>
                    <ReactTable
                        data={taskData.map((task, i, self) => {
                            const fDate = date => moment(date).format('YYYY-MM-DD HH:mm');

                            const assignedAt = fDate(task.taskAssignedAt.toDate());
                            const dueDate = fDate(task.taskDueDate.toDate());

                            return ({
                                ...task,
                                orderID: task.orderID ? task.orderID : <p>'From Shipper'</p>,
                                taskAssignedAt: assignedAt,
                                taskDueDate: (
                                    <p style={{ color: (moment().isAfter(moment(task.taskDueDate.toDate())) && !task.completed) ? 'red' : '' }}>{dueDate}</p>
                                ),
                                completed: (
                                    <GreenCheckbox
                                        checked={Boolean(task.completed)}
                                        onChange={(e) => this.handleToggleCompletedChange(e, i)}
                                        name="completed"
                                        style={{
                                            marginLeft: '4px'
                                        }}
                                    />

                                ),
                                taskAssigner: task.taskAssigner.name,
                                taskAssignee: task.taskAssignee.name,
                                goToOrder: task.entityID ? (
                                    <a href={`/${task.profileType}/${task.entityID}`}>
                                        <Button
                                            color="success"
                                        >
                                            Go To Entity
                                        </Button>
                                    </a>
                                ) : task.orderID ? (
                                    <a href={`/order/${task.orderID}`}>
                                        <Button
                                            color="success"
                                        >
                                            Go To Order
                                        </Button>
                                    </a>
                                ) : null
                            })
                        })}
                        filterable
                        columns={this.taskColumns}
                        defaultPageSize={10}
                        style={{
                            color: "#000",
                            border: "solid 1px black"
                        }}
                        className="-striped -highlight"
                    />
                </GridItem>
            </GridContainer>
        ) : null;
    }
}

const mapStateToProps = (state, ownProps) => {
    //console.log(state)
    return {
        AuthBool: !!state.auth.user,
        authUser: state.auth.user,
        user: state.profile.user,
        // orderID: ownProps.match.params.id
    }
}

export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(TaskViewer);


// WEBPACK FOOTER //
// ./src/components/Tasks/TaskViewer.jsx